/*
	* ================================================
	*	Helpers
	* ================================================
*/

export function isEmpty(obj) {
	for (let key in obj) {
		return false;
	}
	return true;
}

export function isEmailValid(email) {
	const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

	return EMAIL_REGEXP.test(email);
}

export function isURLValid(value) {
	const URL_REGEXP = /^(((https?|ftp):\/\/)?([a-z0-9-]+\.)?[a-z0-9-]+\.[a-z]{2,}(\/[^\s]*)?|@\w+)$/gmi;

	return URL_REGEXP.test(value);
}

export function isPhoneValid(value) {
	const phoneRegex = /^\+?\d{11,15}$/;
	
	return phoneRegex.test(value);
}

/**
 * Performs validation of form fields.
 * @param {NodeList} fields - List of wrappers for form fields (<div class="data-input">).
 * @returns {boolean} - Returns true if there are validation errors, otherwise - false.
 */
export function formFieldsValidation(fields) {
	let hasError = false;

	fields.forEach(item => {
		const field = item.querySelector('input[required]');

		if (!field) {
			return
		}

		if (field.type === 'email') {
			if (!isEmailValid(field.value)) {
				item.classList.add('novalid');
				hasError = true;
			} else {
				item.classList.remove('novalid');
			}
		} else if (field.type === 'tel') {
			if (!isPhoneValid(field.value)) {
				item.classList.add('novalid');
				hasError = true;
			} else {
				item.classList.remove('novalid');
			}
		} else if (field.type === 'password') {
			if (field.value.length < 8) {
				item.classList.add('novalid');
				hasError = true;
			} else {
				item.classList.remove('novalid');
			}
		} else {
			if (isEmpty(field.value)) {
				item.classList.add('novalid');
				hasError = true;
			} else {
				item.classList.remove('novalid');
			}
		}
	});

	return hasError;
};


export function sleep(time) {
	return new Promise(resolve => {
		setTimeout(() => {
			resolve();
		}, time);
	});
}

export async function loadScript(src, wait = false) {
	var head = document.getElementsByTagName('head')[0]
	var script = document.createElement('script')
	script.type = 'text/javascript';
	script.src = src;
	head.appendChild(script);

	if (wait) {
		await sleep(wait);
	}
}

export async function loadCaptcha() {
	await loadScript(`https://www.google.com/recaptcha/api.js?render=${WclConfig.recaptcha_key}`);

	do {
		await sleep(100);
	} while (typeof grecaptcha === "undefined");
}


/**
* Send request function
* @param {string} action - The server response handler function.
* @param {string} args - Additional arguments in the form of query parameters (e.g., 'a=1&b=2&c=3').
* @returns {Promise} - A Promise that resolves with the server's response or rejects with an error message.
*/
export function SendRequest(action, args = '') {
	return new Promise(async (resolve, reject) => {

		await loadCaptcha();

		// Check if grecaptcha is not equal to "undefined"
		if (typeof grecaptcha === "undefined") {
			return;
		}

		grecaptcha.ready(function () {
			grecaptcha.execute(WclConfig.recaptcha_key, {
				action: 'wcl_grecaptcha'
			}).then(function (token) {

				// Create a request
				const httpRequest = new XMLHttpRequest();

				// Checking if the request exists
				if (!httpRequest) {
					reject('Giving up :( Cannot create an XMLHTTP instance');
				}

				httpRequest.open('POST', '/wp-admin/admin-ajax.php');
				httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

				httpRequest.onload = () => {
					if (httpRequest.status >= 200 && httpRequest.status < 300) {
						// If successful
						resolve(httpRequest.responseText);
					} else {
						// Connection error
						reject(httpRequest.statusText);
					}
				}

				httpRequest.onerror = function () {
					// Connection error
					reject(httpRequest.statusText);
				};

				httpRequest.send(`action=${action}&token=${token}${args}`);

			});
		});


	});
}



/**
* Function for sending form data to the server.
* @param {string} action - The action to be performed on the server.
* @param {FormData} formData - The FormData object containing the form data to be sent.
* @returns {Promise} - A Promise that resolves with the server's response or rejects with an error message.
*/
export function SendFormData(action, formData) {
	return new Promise(async (resolve, reject) => {

		await loadCaptcha();

		// Check if grecaptcha is not equal to "undefined"
		if (typeof grecaptcha === "undefined") {
			reject('grecaptcha is not defined');
			return;
		}

		grecaptcha.ready(function () {
			grecaptcha.execute(WclConfig.recaptcha_key, { action: 'wcl_grecaptcha' }).then(function (token) {

				// Create a request
				const httpRequest = new XMLHttpRequest();

				// Checking if the request exists
				if (!httpRequest) {
					reject('Giving up :( Cannot create an XMLHTTP instance');
					return;
				}

				httpRequest.open('POST', '/wp-admin/admin-ajax.php');

				// Remove the header to allow XMLHttpRequest to set 'Content-Type' automatically
				// httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');

				httpRequest.onload = () => {
					if (httpRequest.status >= 200 && httpRequest.status < 300) {
						// If successful
						resolve(httpRequest.responseText);
					} else {
						// Connection error
						reject(httpRequest.statusText);
					}
				};

				httpRequest.onerror = () => {
					// Connection error
					reject(httpRequest.statusText);
				};

				// Add the action name and token to formData
				formData.append('action', action);
				formData.append('token', token);

				// Send formData
				httpRequest.send(formData);

			});
		});
	});
}




/*
* Functions to work with cookies in js
*/
export function createCookie(name, value, days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		var expires = "; expires=" + date.toGMTString();
	} else var expires = "";
	document.cookie = name + "=" + value + expires + "; path=/";
}

export function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

export function addToCookieArray(cookieName, newValue) {
	var cookieValue = readCookie(cookieName);
	var myArray;
	if (cookieValue) {
		myArray = JSON.parse(cookieValue);
	} else {
		myArray = [];
	}
	myArray.push(newValue);
	createCookie(cookieName, JSON.stringify(myArray), 7);
}

export function eraseCookie(name) {
	createCookie(name, "", -1);
}